// extracted by mini-css-extract-plugin
module.exports = {"DailyTiles":"DailyTiles_DailyTiles__2h0HE","spin":"DailyTiles_spin__Tw17q","transition-opacity":"DailyTiles_transition-opacity__1gC2x"};